import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/no-data-list.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-15f90fbc")

_pushScopeId("data-v-15f90fbc")
const _hoisted_1 = { class: "pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "grid grid-cols-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "" }, null, -1)
const _hoisted_5 = { class: " flex flex-col justify-center items-center mb-5" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row justify-end items-end self-end mb-2"
}
const _hoisted_7 = {
  class: "rounded-lg px-3 py-2 flex flex-col",
  style: {"border":"1px solid #D4D5D8","height":"100px","margin-top":"5rem"}
}
const _hoisted_8 = { class: "text-16px font-semibold text-black" }
const _hoisted_9 = {
  class: "text-20px font-bold font-montserrat",
  style: {"color":"#00875A"}
}
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "text-16px font-medium text-gray-lp-800" }, " STI DEST ", -1)
const _hoisted_11 = { class: "flex flex-row items-center gap-x-2" }
const _hoisted_12 = {
  class: "flex",
  style: {"margin-left":"-17px"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "w-1/3 bg-gray-lp-300" }, null, -1)
const _hoisted_14 = { class: "flex flex-row items-center gap-x-2" }
const _hoisted_15 = { class: "flex flex-row justify-between items-center w-full mt-3" }
const _hoisted_16 = {
  class: "flex flex-row border rounded-lg px-6 py-3 gap-x-7",
  style: {"border-color":"#eee"}
}
const _hoisted_17 = { class: "flex flex-row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal text-gray-lp-800" }, "Total STT", -1)
const _hoisted_19 = { class: "ml-5 text-14px font-bold text-black-lp-100" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"1px","background":"#D4D5D8"},
  class: "h-auto mx-4"
}, null, -1)
const _hoisted_21 = { class: "flex flex-row" }
const _hoisted_22 = { class: "text-14px font-normal text-gray-lp-800" }
const _hoisted_23 = { class: "ml-5 text-14px font-bold text-black-lp-100" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"1px","background":"#D4D5D8"},
  class: "h-auto mx-4"
}, null, -1)
const _hoisted_25 = { class: "flex flex-row" }
const _hoisted_26 = { class: "text-14px font-normal text-gray-lp-800" }
const _hoisted_27 = { class: "ml-5 text-14px font-bold text-black-lp-800" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "" }, null, -1)
const _hoisted_29 = { class: "relative" }
const _hoisted_30 = {
  key: 0,
  class: "flex justify-center w-full",
  style: {"height":"50vh"}
}
const _hoisted_31 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "not-data-list",
  width: "160",
  height: "135"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Invalid = _resolveComponent("Invalid")!
  const _component_Illustration = _resolveComponent("Illustration")!
  const _component_EmptyScan = _resolveComponent("EmptyScan")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Select = _resolveComponent("Select")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_DetailLayout, {
        onBack: _ctx.goBack,
        title: _ctx.$t('stiDest.update.title'),
        "vertical-separator": false,
        "is-floating-action": true,
        fullPage: ""
      }, {
        data: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                (_ctx.isInvalid || _ctx.isErrorValidationScan)
                  ? (_openBlock(), _createBlock(_component_Invalid, {
                      key: 0,
                      isUnpaid: _ctx.isUnpaid
                    }, null, 8, ["isUnpaid"]))
                  : _createCommentVNode("", true),
                (_ctx.savedSttNo)
                  ? (_openBlock(), _createBlock(_component_Illustration, {
                      key: 1,
                      isSTT: _ctx.isSTT,
                      isTransit: _ctx.isTransit,
                      isDangerousGoods: _ctx.isDangerousGoods,
                      isWoodpacking: _ctx.isWoodpacking,
                      cityCode: _ctx.cityCode,
                      isMisroute: _ctx.isMisroute,
                      flag: _ctx.flag,
                      isPartial: _ctx.isPartial,
                      isRelabel: _ctx.isRelabel
                    }, null, 8, ["isSTT", "isTransit", "isDangerousGoods", "isWoodpacking", "cityCode", "isMisroute", "flag", "isPartial", "isRelabel"]))
                  : _createCommentVNode("", true),
                (_ctx.isDuplicateScan)
                  ? (_openBlock(), _createBlock("img", {
                      key: 2,
                      src: _ctx.$i18n.locale === 'id' ? require('@/app/ui/assets/svg/sti-reverse-scan/duplicate-scan-label.svg') : require('@/app/ui/assets/svg/sti-reverse-scan/duplicate-scan-label-en.svg'),
                      alt: _ctx.$t('STT Sudah Di Scan'),
                      width: "280",
                      height: "45",
                      class: "mt-2",
                      style: {"max-width":"100%","height":"auto"}
                    }, null, 8, ["src", "alt"]))
                  : _createCommentVNode("", true),
                (
                  !_ctx.dataSttToBeUpdate.data.length &&
                    !(_ctx.isInvalid || _ctx.isErrorValidationScan) &&
                    !_ctx.savedSttNo
                )
                  ? (_openBlock(), _createBlock(_component_EmptyScan, { key: 3 }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.savedSttNo)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("p", _hoisted_8, _toDisplayString(_ctx.isSTT
                      ? _ctx.$t("stiDest.update.lastStt")
                      : _ctx.$t("stiDest.update.lastBag")), 1),
                      _createVNode("p", _hoisted_9, _toDisplayString(_ctx.savedSttNo), 1),
                      _hoisted_10
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_LpInput, {
              onFocus: _ctx.onSetFocusRefs,
              ref: "inputStt",
              onEnter: _ctx.addScanSttNumber,
              sizeInput: "24px",
              labelStacked: _ctx.$t('stiDest.update.labelStackedStt'),
              modelValue: _ctx.form.sttNumber,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.sttNumber = $event)),
              placeholder: _ctx.$t('stiDest.update.placeholderStt'),
              bold: !!_ctx.form.sttNumber,
              error: _ctx.isErrorValidationScan,
              onChange: _ctx.onChangeStt,
              errorCaption: _ctx.errorCaption,
              isErrorIconCaption: _ctx.errorCaption.length,
              labelStackedCenter: "",
              isErrorIconInput: false
            }, null, 8, ["onFocus", "onEnter", "labelStacked", "modelValue", "placeholder", "bold", "error", "onChange", "errorCaption", "isErrorIconCaption"])
          ]),
          _createVNode("div", null, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_Search, {
                class: "w-64 self-center",
                onInput: _ctx.onSearch,
                onClear: _ctx.clearSearch,
                value: _ctx.searchValue,
                placeholder: _ctx.$t('stiDest.update.placeholderStt'),
                minChar: 1,
                timeout: 500
              }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", {
                  class: 
                  `border ${
                    _ctx.misroute.status
                      ? ' border-red-lp-500 text-red-lp-500 font-semibold bg-red-lp-1300'
                      : ' border-gray-lp-400 text-gray-lp-600'
                  } rounded-md px-4 py-2 text-14px xl:text-14px xxl:text-14px cursor-pointer`
                ,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setIsMisroute && _ctx.setIsMisroute(...args)))
                }, _toDisplayString(_ctx.misroute.title), 3)
              ]),
              _createVNode(_component_Select, {
                dataSelect: _ctx.statusReturnList,
                onChooseSelect: _ctx.onSelectStatusReturn,
                onOpenSelect: _ctx.onOpenSelect,
                onCloseSelect: _ctx.onCloseSelect,
                isOpenMenu: _ctx.isOpenStatusReturn,
                value: _ctx.statusReturn,
                placeholder: _ctx.$t('stiDest.pdf.penandaPaket'),
                class: "w-1/5"
              }, null, 8, ["dataSelect", "onChooseSelect", "onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "placeholder"]),
              _hoisted_13,
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_lp_button, {
                  id: "btnDowloadSTIDest",
                  iconLeft: "download-new",
                  iconV2: "",
                  title: "Download",
                  textColor: "red-lp-300",
                  customClass: "w-36",
                  outline: "",
                  small: "",
                  onClick: _ctx.handleDownloadCsv,
                  class: "right-0",
                  disabled: !_ctx.dataSttToBeUpdate.data.length
                }, null, 8, ["onClick", "disabled"]),
                _createVNode(_component_lp_button, {
                  id: "btnDownloadManifest",
                  title: _ctx.$t('stiDest.pdf.prosesManifest'),
                  textColor: "white",
                  onClick: _ctx.handleProcessManifest,
                  disabled: !_ctx.dataSttToBeUpdate.data.length
                }, null, 8, ["title", "onClick", "disabled"])
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("p", _hoisted_19, _toDisplayString(_ctx.formatQuantity(_ctx.totalStt)), 1)
                ]),
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  _createVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("stiDest.pdf.beratKotorShort")), 1),
                  _createVNode("p", _hoisted_23, _toDisplayString(_ctx.formatWeight(_ctx.totalGrossWeight)) + " kg ", 1)
                ]),
                _hoisted_24,
                _createVNode("div", _hoisted_25, [
                  _createVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("stiDest.pdf.totalKoli")), 1),
                  _createVNode("p", _hoisted_27, _toDisplayString(_ctx.formatQuantity(_ctx.totalPieces)), 1)
                ])
              ]),
              _hoisted_28
            ]),
            _createVNode("div", _hoisted_29, [
              (!_ctx.dataSttToBeUpdate.data.length && !_ctx.listLoading)
                ? (_openBlock(), _createBlock("div", _hoisted_30, [
                    _hoisted_31
                  ]))
                : (_openBlock(), _createBlock(_component_TableV2, {
                    key: 1,
                    loading: _ctx.listLoading,
                    iconEmpty: "empty-reverse-scan",
                    data: _ctx.dataSttToBeUpdate.data,
                    columns: _ctx.columns,
                    borderTop: false,
                    pagination: _ctx.pagination,
                    "is-hard-pagination": true,
                    "pagination-style": "v2",
                    isRightFreeze: "",
                    totalColumnFreeze: 3,
                    isPinnedScrollBottom: "",
                    emptyMessage: "",
                    buttonAction: "",
                    bgHeader: "bg-white",
                    errorCause: _ctx.errorType,
                    onTryAgain: _ctx.getSession
                  }, null, 8, ["loading", "data", "columns", "pagination", "errorCause", "onTryAgain"]))
            ])
          ])
        ]),
        _: 1
      }, 8, ["onBack", "title"])
    ]),
    (_ctx.isModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onSubmit: _ctx.alertPopup.onClick,
          title: _ctx.alertPopup.title,
          message: _ctx.alertPopup.message,
          image: _ctx.alertPopup.image,
          textSuccess: "OK",
          class: "px-8",
          customButton: "px-6"
        }, null, 8, ["onSubmit", "title", "message", "image"]))
      : _createCommentVNode("", true)
  ], 64))
})